import { render, staticRenderFns } from "./StatusFilters.vue?vue&type=template&id=528f577a&scoped=true&"
import script from "./StatusFilters.vue?vue&type=script&lang=js&"
export * from "./StatusFilters.vue?vue&type=script&lang=js&"
import style0 from "./StatusFilters.vue?vue&type=style&index=0&id=528f577a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f577a",
  null
  
)

export default component.exports